export default {
    municipality: 'Välj Kommun',
    voters: '1000',
    votingareas: '0',
    participation: '0',
    registeredVoters: '0',
}
